<template>
	<div class="features-bg">
	 	<b-container class="py-5">
			<b-row class="pb-2 text-light">
				<b-col>
					<h1>Linked Data Features</h1>
				</b-col>
			</b-row>
	 		<b-row v-for="feature in featureText">
        <b-col>
          <p class="py-1" style="font-size: 26px">
            <span class="text-danger" style="font-weight: bold">
              {{ feature.title }}
            </span>
            <span class="text-light">
              {{ feature.description }}
            </span>
          </p>
        </b-col>

			</b-row>
		</b-container>
	</div>
</template>

<script>
export default {
  name: 'featuresContent',
  computed: {
    featureText() {
      return this.$store.state.featureText;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*.features-bg {
	background-image: url("../assets/purple_plexus_bg_02b.png");
	background-repeat: no-repeat;
	background-size: cover;
  background-attachment: fixed;
}*/
.features-bg:before {
  content: "";
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -10;
  background: url("../assets/purple_plexus_bg_02b.png") no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>
